"use strict"

angular.module("core")
.service("ConvertToParameterService", function() {
    this.convertTagsToParameter = function(selectedTags) {
        var selectedTagParameters = [];

        angular.forEach(selectedTags, function(value, key) {
            if (selectedTags[key].selected) {
                this.push(value.tag);
            }
        }, selectedTagParameters);

        if (selectedTagParameters.length > 0) {
            return selectedTagParameters.join(",");
        }
        else {
            return null;
        }
    };

    this.convertValuesToParameter = function(selectedValues) {
        var selectedValuesParameters = [];

        angular.forEach(selectedValues, function(value, key) {
            if (selectedValues[key]) {
                this.push(key);
            }
        }, selectedValuesParameters);

        if (selectedValuesParameters.length) {
            return selectedValuesParameters.join(",");
        }
        else {
            return null;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/convert-to-parameter/convert-to-parameter.service.js
// module id = 439
// module chunks = 0